import { Locale } from "types/locale";

import { NumberString } from "../../pages/VehicleCondition/types";

export const formatNumberIntl = (
  number: NumberString,
  locale: Locale,
  options: Intl.NumberFormatOptions = {}
): string => {
  const formattedLocale = locale.replace("_", "-");
  const formatter = new Intl.NumberFormat(formattedLocale, options);

  return formatter.format(Number(number));
};
